var IconListModule = /** @class */ (function () {
    function IconListModule() {
    }
    return IconListModule;
}());
export { IconListModule };
